const mapboxAssets = [
   'https://api.tiles.mapbox.com/mapbox-gl-js/v0.49.0/mapbox-gl.js',
   'https://api.tiles.mapbox.com/mapbox-gl-js/v0.49.0/mapbox-gl.css',
];

new AssetGroup(mapboxAssets, {
   onComplete: function () {
      mapboxgl.accessToken = App.mapboxApiKey;

      const loc = new mapboxgl.LngLat(App.longitude, App.latitude);

      const map = new mapboxgl.Map({
         container: 'mapContainer',
         style: 'mapbox://styles/mapbox/streets-v10',
         center: loc,
         zoom: 4,
      });

      new mapboxgl.Marker().setLngLat([App.longitude, App.latitude]).addTo(map);

      const nav = new mapboxgl.NavigationControl({
         showZoom: true,
         showCompass: false,
      });

      map.addControl(nav, 'top-left');

      document.querySelector('.mapboxgl-ctrl-logo').makeInvisible();
   },
});
